import React from 'react';
import AppRouter from './app-router';

const App = () => {
  // handleMessages = msg => {
  //     // important: this class method name is picked up by HOC, don't change
  //     console.info('msg', msg);
  //     const { type, payload } = msg;
  //     if (type === 'SELF') {
  //         setAuthHeaders(payload.token);
  //         this.props.initData(payload);
  //     }
  // };
  return <AppRouter />;
}

export default App;
